import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';

import './App.css';

import Header from './components/header.component';
import Footer from './components/footer.component';
import Gallery from './components/gallery.component';
import ShareOptions from './components/share.component';

class App extends Component {
  render() {
    return (
      <React-Fragment>
        {/* <MetaTags>
          <title>Alsoug La7azat</title>
          <meta name="description" content="Alsoug La7azat. Gallery view for Sudan events" />
          <meta property="og:title" content="Alsoug La7azat" />
          <meta property="og:image" content={`${window.location.origin}/cover/cover-1.png`} />
        </MetaTags> */}
        <Header />
        <Gallery />
        <Footer />
        <ShareOptions />
      </React-Fragment>
    );
  }
}

export default App;
